import React from 'react'
import Oralcare from '@components/brand/oralcare'

const OralcarePage = () => {
  return <Oralcare />
}

export default OralcarePage
